export default "__VITE_ASSET__5edf4e02__"